import {
   Component, ContentChildren, EventEmitter, HostListener, Input, Output,
  QueryList
} from '@angular/core';
import {DropdownOptionComponent} from './dropdownoption/component';

@Component({
  selector: 'dropdown',
  template: `<div class="dropdown_wrapper" [class.disabled]="disabled">
  <div *ngFor="let option of dropdownOptions; index as i">
    <div class="dropdown_select text--small"
         *ngIf = "dropdown_option === i"
         (click)="openSelection()">
      <ng-container *ngTemplateOutlet="option.template"></ng-container>
    </div>
  </div>
  <div class="dropdown_list" *ngIf="opened">
    <ul>
      <li *ngFor="let option of dropdownOptions; index as i" [class.active] = "dropdown_option === i"
          (click) = "changeSelection(i)">
        <ng-container *ngTemplateOutlet="option.template"></ng-container>
      </li>
    </ul>
  </div>
</div>
`,
  styles: [`.dropdown_wrapper{position:relative;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.dropdown_wrapper.disabled{pointer-events:none;opacity:.5}.dropdown_wrapper .dropdown_select{padding:15px 30px;border:1px solid #cbcbcb;border-radius:5px;color:#878787;overflow:hidden}.dropdown_wrapper .dropdown_select::after{content:'';float:right;margin-top:8px;margin-left:30px;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #000}.dropdown_wrapper .dropdown_select:hover{cursor:pointer;border:1px solid #000;color:#000}.dropdown_wrapper .dropdown_select.none{display:none}.dropdown_wrapper .dropdown_list{position:absolute;width:100%;top:0;left:0;z-index:100;background:#f8f8f8;border-radius:5px;border:1px solid #0081e3;box-shadow:0 8px 16px 0 rgba(0,0,0,.2);overflow:hidden}.dropdown_wrapper .dropdown_list ul{list-style:none;margin:0;padding:0;background:#f8f8f8}.dropdown_wrapper .dropdown_list li{padding:10px 30px}.dropdown_wrapper .dropdown_list li span{color:#878787}.dropdown_wrapper .dropdown_list li:hover{cursor:pointer;background:#0081e3;color:#fff}.dropdown_wrapper .dropdown_list li:hover>span{color:#fff}.dropdown_wrapper .dropdown_list li:active,.dropdown_wrapper .dropdown_list li:active>span{background:#0064b0;color:#fff}.dropdown_wrapper .dropdown_list li.active,.dropdown_wrapper .dropdown_list li.active>span{background:#0081e3;color:#fff}`]
})
export class DropdownComponent {

  @ContentChildren(DropdownOptionComponent) dropdownOptions: QueryList<DropdownOptionComponent>;

  @Input('disabled') disabled: boolean;
  @Output('select') select: EventEmitter<number> = new EventEmitter<number>();

  private _opened: boolean;
  private _dropdown_option: number;

  constructor() {
    this.dropdown_option = 0
  }

  public set opened(opt: boolean) {
    this._opened = opt;
  }

  public get opened() {
    return this._opened;
  }

  set dropdown_option(opt: number) {
    this._dropdown_option = opt;
  }

  get dropdown_option() {
    return this._dropdown_option;
  }

  public openSelection(): void {
    this.opened = !this.opened;
  }

  public changeSelection(selection: number): void {
    this.dropdown_option = selection;
    this.opened = false;
  }

  @HostListener('click')
  click() {
    this.select.emit(this.dropdown_option);
  }

}
